import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const Wrapper = styled(motion.div)<{ $showCompact?: boolean }>`
    width: 100%;
    height: 100%;

    background: #151327;
    box-shadow: 0 15px 25px rgba(0, 0, 0, 0.5);
    border-radius: 0;

    display: flex;
    flex-direction: column;

    overflow-y: auto;

    img {
        width: 100%;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 480px;
        height: 100%;
        border-radius: 30px;
        overflow: unset;

        ${({ $showCompact }) =>
            !$showCompact &&
            css`
                overflow: hidden;
            `}
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 520px;
    }
`;
